export enum ProductCategory {
  CORN = 'Corn',
  CANOLA_HYBRID = 'Canola',
  SOYBEAN = 'Soybean',
}
